/* RESPONSIBLE TEAM: team-actions */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import type SetupAction from 'embercom/models/workflow-connector/setup-action';
import type ArrayProxy from '@ember/array/proxy';
import type McpActions from 'embercom/models/workflow-connector/mcp-actions';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';

export default class CustomActions extends SettingsRoute {
  @service declare store;
  @service declare appService: $TSFixMe;
  @service declare intercomEventService;
  @service declare permissionsService: $TSFixMe;
  @service declare intl: IntlService;

  analytics = {
    section: 'settings',
    place: 'action-builder',
  };

  get titleToken() {
    return this.intl.t('new-settings.app-settings.custom-actions.action-builder-title');
  }

  async model() {
    if (this.appService.app.canUseMcpActions) {
      let [mcpActions, mcpServers]: [ArrayProxy<McpActions>, ArrayProxy<McpServer>] =
        await Promise.all([
          this.store.query('workflow-connector/mcp-actions', {}),
          this.store.findAll('workflow-connector/mcp-server'),
        ]);

      return {
        mcpActions,
        mcpServers,
        templateActions: [],
        actions: [],
      };
    } else {
      let actions: ArrayProxy<SetupAction> = await this.store.query(
        'workflow-connector/setup-action',
        {},
      );

      if (!actions) {
        return {
          actions: [],
          templateActions: [],
          mcpActions: [],
          mcpServers: [],
        };
      }

      let workflowActions = actions.filterBy('isTemplate', false);
      let templateActions = actions.filterBy('isTemplate', true);

      return {
        actions: workflowActions,
        templateActions,
        mcpActions: [],
        mcpServers: [],
      };
    }
  }

  @action
  didTransition() {
    super.didTransition();
    this.intercomEventService.trackEvent('has_visited_custom_actions');
  }
}
